export default __webpack_public_path__ + "static/media/yellow-frame.5e1f9911.png";